import { Component, OnInit } from "@angular/core";
import { Router, Event, NavigationEnd } from "@angular/router";
import { PermissionTypeEnum } from "src/app/common/permission-enum";
import { ViewType } from "src/app/enums/view-type.enum";
import { AuthenticationService } from "../../pages/authentication/authentication/authentication.service";
import { ThemeService } from "src/app/services/theme.service";
declare let $: any;

@Component({
    selector: "app-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.scss"]
})
export class SidebarComponent implements OnInit {
    showElement = false;
    permissionType = PermissionTypeEnum;
    viewType = ViewType;
    view = null;
    logoSrc = 1;

    constructor(private router: Router, private authService: AuthenticationService, private themeService: ThemeService) {

        router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                $(".responsive-burger-menu").removeClass("active");
                $(".sidemenu-area").removeClass("active-sidemenu-area");
            }
        });
    }

    ngOnInit() {
        this.setLogoByTheme(this.themeService.getCurrentTheme());
        this.view = this.authService.getView();
        // Burger Menu JS
        $(".burger-menu").on("click", function () {
            $(this).toggleClass("active");
            $(".main-content").toggleClass("hide-sidemenu-area");
            $(".sidemenu-area").toggleClass("toggle-sidemenu-area");
            $(".top-navbar").toggleClass("toggle-navbar-area");
        });
        $(".responsive-burger-menu").on("click", function () {
            $(".responsive-burger-menu").toggleClass("active");
            $(".sidemenu-area").toggleClass("active-sidemenu-area");
        });
    }

    private setLogoByTheme(theme: string | null) {
        switch (theme) {
            case 'blue-theme':
                this.logoSrc = 1;
                break;
            case 'green-theme': //Extracciones
                this.logoSrc = 2;
                break;
            case 'yellow-theme':  //Alfa y Omega
                this.logoSrc = 3;
                break;
            case 'food-theme':  // Alimentos
                this.logoSrc = 4;
                break;
            default:
                this.logoSrc = 1;
        }
    }
}
